<div *ngIf="backdrop" class="backdrop"></div>
<div id="{{idElement}}" class="popup-wrapper">
  <div class="popup-container">
    <ng-content select="pop-up-title"></ng-content>
    <ng-content select="pop-up-content"></ng-content>
    <ng-content></ng-content>
  </div>
</div>
